// extracted by mini-css-extract-plugin
export var band = "color-bar-module--band--c4d2c";
export var bands = "color-bar-module--bands--66ec9";
export var color = "color-bar-module--color--c3d74";
export var root = "color-bar-module--root--71da6";
export var sticky = "color-bar-module--sticky--c8f35";